import React from "react";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import lyneImage from "../assets/images/lyne.jpeg";
import TazImage from "../assets/images/taz.jpeg";
import JoelImage from "../assets/images/joel.jpeg";
import FleuryImage from "../assets/images/fleury.jpeg";
import VictorImage from "../assets/images/victor.jpeg";
import ZenonImage from "../assets/images/zenon.jpeg";
import HonoraImage from "../assets/images/Honora.jpeg";

const Equipe = () => {
  const equipe = {
    direction: [
      {
        nom: "Dr. Guy Fleury Taty",
        role: "Kinésithérapeute",
        specialite: "Médecine Générale",
        photo: FleuryImage, // À remplacer par la vraie photo
        bio: "Spécialisé en rééducation musculo-squelettique, en thérapie manuelle et en kinésithérapie respiratoire, il accompagne ses patients dans leur processus de récupération avec une approche personnalisée et globale. Il accorde une grande importance à l'écoute, au suivi individualisé, et à l'éducation thérapeutique.",
      },
      {
        nom: "Zenon Sima",
        role: "Data Scientiist",
        specialite: "Intelligence Artificielle",
        photo: ZenonImage, // À remplacer par la vraie photo
        bio: "L'expertise couvre tout le cycle de vie des projets IA, de la collecte et du nettoyage des données jusqu'au déploiement de modèles d'apprentissage automatique et de deep learning. Il accorde une importance particulière à l'interprétabilité des modèles, à l'éthique de l'IA et à l'impact sociétal de ses solutions.",
      },
    ],
    medical: [
      {
        nom: "Dr.Horlyne Mavoungou",
        role: "Infirmière polyvalente",
        specialite: "Médecine Générale",
        photo: lyneImage,
        bio: "Spécialiste en médecine préventive avec une expertise particulière dans les maladies tropicales.",
      },
      {
        nom: "Dr. Iloky Victoria",
        role: "Cardiologue",
        specialite: "Médecine Générale",
        photo: VictorImage, // À remplacer par la vraie photo
        bio: "Cardiologue renommé ayant développé des protocoles de téléconsultation adaptés au contexte africain.",
      },
    ],
    technique: [
      {
        nom: "Tazmanie Louya",
        role: "Lead Déveloper",
        specialite: "Applications Mobiles",
        photo: TazImage, // À remplacer par la vraie photo
        bio: "Experte en développement mobile avec une passion pour l'accessibilité numérique.",
      },
      {
        nom: "Joel Gantshua",
        role: "Architecte Solution",
        specialite: "Sécurité des Données",
        photo: JoelImage, // À remplacer par la vraie photo
        bio: "Spécialiste en sécurité des données de santé et en conformité réglementaire.",
      },
      {
        nom: "Honora Mpassi",
        role: "Technicien réseaux",
        specialite: "Sécurité des Données",
        photo: HonoraImage, // À remplacer par la vraie photo
        bio: "Spécialiste en sécurité des données de santé et en conformité réglementaire.",
      },
    ],
  };

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Notre Équipe
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des experts passionnés qui œuvrent chaque jour pour améliorer l'accès aux soins en Afrique
          </p>
        </motion.div>

        {/* Direction */}
        <section className="mb-20">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="text-2xl font-bold text-gray-900 mb-8"
          >
            Direction
          </motion.h2>
          <motion.div
            variants={container}
            initial="hidden"
            animate="show"
            className="grid grid-cols-1 md:grid-cols-2 gap-8"
          >
            {equipe.direction.map((membre) => (
              <motion.div
                key={membre.nom}
                variants={item}
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <div className="aspect-w-16 aspect-h-9 bg-gray-200 p-4">
                  {membre.photo ? (
                    <img
                      src={membre.photo}
                      alt={membre.nom}
                      className="w-full h-40 object-contain rounded-lg"
                    />
                  ) : (
                    <div className="flex items-center justify-center h-40 bg-blue-100 rounded-lg">
                      <span className="text-4xl">👤</span>
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {membre.nom}
                  </h3>
                  <p className="text-blue-600 font-medium mb-2">{membre.role}</p>
                  <p className="text-gray-500 mb-4">{membre.specialite}</p>
                  <p className="text-gray-600">{membre.bio}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </section>

        {/* Équipe Médicale */}
        <section className="mb-20">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="text-2xl font-bold text-gray-900 mb-8"
          >
            Équipe Médicale
          </motion.h2>
          <motion.div
            variants={container}
            initial="hidden"
            animate="show"
            className="grid grid-cols-1 md:grid-cols-2 gap-8"
          >
            {equipe.medical.map((membre) => (
              <motion.div
                key={membre.nom}
                variants={item}
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <div className="aspect-w-16 aspect-h-9 bg-gray-200 p-4">
                  {membre.photo ? (
                    <img
                      src={membre.photo}
                      alt={membre.nom}
                      className="w-full h-40 object-contain rounded-lg"
                    />
                  ) : (
                    <div className="flex items-center justify-center h-40 bg-blue-100 rounded-lg">
                      <span className="text-4xl">👤</span>
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {membre.nom}
                  </h3>
                  <p className="text-blue-600 font-medium mb-2">{membre.role}</p>
                  <p className="text-gray-500 mb-4">{membre.specialite}</p>
                  <p className="text-gray-600">{membre.bio}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </section>

        {/* Équipe Technique */}
        <section className="mb-20">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="text-2xl font-bold text-gray-900 mb-8"
          >
            Équipe Technique
          </motion.h2>
          <motion.div
            variants={container}
            initial="hidden"
            animate="show"
            className="grid grid-cols-1 md:grid-cols-2 gap-8"
          >
            {equipe.technique.map((membre) => (
              <motion.div
                key={membre.nom}
                variants={item}
                className="bg-white rounded-lg shadow-lg overflow-hidden"
              >
                <div className="aspect-w-16 aspect-h-9 bg-gray-200 p-4">
                  {membre.photo ? (
                    <img
                      src={membre.photo}
                      alt={membre.nom}
                      className="w-full h-40 object-contain rounded-lg"
                    />
                  ) : (
                    <div className="flex items-center justify-center h-40 bg-blue-100 rounded-lg">
                      <span className="text-4xl">👤</span>
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {membre.nom}
                  </h3>
                  <p className="text-blue-600 font-medium mb-2">{membre.role}</p>
                  <p className="text-gray-500 mb-4">{membre.specialite}</p>
                  <p className="text-gray-600">{membre.bio}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </section>

        {/* Call to Action */}
        <motion.section
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-blue-50 rounded-lg p-8 text-center"
        >
          <h2 className="text-2xl font-semibold text-blue-900 mb-4">
            Rejoignez notre équipe !
          </h2>
          <p className="text-blue-700 mb-6 max-w-2xl mx-auto">
            Nous sommes toujours à la recherche de talents passionnés pour nous aider
            à transformer l'accès aux soins en Afrique.
          </p>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => window.location.href = "/contact"}
            className="bg-blue-600 text-white px-8 py-3 rounded-full font-medium hover:bg-blue-700 transition-colors"
          >
            Voir nos offres d'emploi
          </motion.button>
        </motion.section>
      </div>
    </div>
  );
};

export default Equipe;